import { render } from "./PaymentMethodLoader.vue?vue&type=template&id=33476919&scoped=true&ts=true"
import script from "./PaymentMethodLoader.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodLoader.vue?vue&type=script&lang=ts"

import "./PaymentMethodLoader.vue?vue&type=style&index=0&id=33476919&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33476919"]])

export default __exports__